// Shimming - this replaces babel-polyfill and is equivalent to using it
// But will have some extra stuff available such as URL and URLSearchParams
import "core-js/stable";
import "regenerator-runtime/runtime";


import $ from 'jquery';
// Assign jQuery to global scope immediately after import for plugin compatibility
window.$ = $;
window.jQuery = $;

// External sources
import svg4everybody from "svg4everybody";
import "lazysizes";
import "../../Sass/carme/global.scss"

// Utils / helpers
import dataLayer from "./modules/dataLayer";
import uiHelpers from "./helpers/ui-helpers";
import lazyLoadImages from "./helpers/lazy-loading-images";
import responsiveTables from "./modules/responsive-tables";
import visible from "./helpers/visible";
import animateOnView from "./helpers/animate-on-view";

//// Core

// Shared
import breadcrumb from "./modules/breadcrumb";
import complianceConfirm from "./modules/compliance-confirm";
import complianceReject from "./modules/compliance-reject";
import concertina from "./modules/concertina";
import contentNotAvailableMessage from "./modules/content-not-available-message";
import cookieBanner from "./modules/cookie-banner";
import fauxDropdown from "./modules/faux-dropdown";
import findAnAdviser from "./modules/find-an-adviser-tool";
import adviserLocationMap from "./modules/adviser-location-map";
import fundTable from "./modules/fund-table";
import header from "./modules/header";
import loginButton from "./modules/login-button";
import modal from "./modules/modal";
import nav from "./modules/nav";
import navSearchToggle from "./modules/nav-search-toggle";
import regionsRolesModalToggle from "./modules/regions-roles-modal-toggle";
import tabs from "./modules/tabs";
import forms from "./modules/forms";
import personBioAlign from "./modules/person-bio-align";
import showcase from "./modules/showcase";
import epiForm from './modules/epi-form';
import savedItems from "./modules/saved-items";
import faqFeedback from "./modules/faq-feedback";

// Mini apps
import searchApp from "./app/search";
import loginApp from "./app/login";
import dividendCaluclatorApp from "./app/dividend-calculator";
import deviceDetectAndRedirectApp from "./app/device-detect-and-redirect";
import cashhubApp from "./app/cashhub";
import cashhubTableApp from "./app/CashHubTable";
import pdfForm from "./app/pdf-form";
import factsetWidgets from "./app/factset";

// Vendor
import loadAmcharts from "./vendor/load-amcharts";
import loadWistiaVideo from "./vendor/load-wistia-video";
import morningstarInvestmentCompare from "./vendor/morningstar/morningstar-investment-compare";
import morningstarReport from "./vendor/morningstar/morningstar-report";
import morningstarScreener from "./vendor/morningstar/morningstar-screener";
import morningstarXray from "./vendor/morningstar/morningstar-xray";
import legacyFindAnAdviser from "./vendor/my-local-adviser";
import civicCookie from "./vendor/civic-cookie";
import responsiveDropdown from "./vendor/responsive-bp/responsive.dropdown";
import responsiveTabs from "./vendor/responsive-bp/responsive.tabs";
import wistiaVideo from "./modules/wistia-video";

svg4everybody();


// Include any plugin initialisation here
// Any custom JS that needs to be written should be modular (and in a separate file), possibly done as a jQuery plugin or some other modular form, and initialised here like the other plugins

$(".no-js").removeClass("no-js");

// Utils
dataLayer.init();
responsiveTables.init();
lazyLoadImages.lazyLoadForegroundImages();
lazyLoadImages.lazyLoadBackgroundImages();
uiHelpers.init();
visible.init();
animateOnView.init();

// Vendor
morningstarScreener.init();
morningstarReport.init();
morningstarXray.init();
morningstarInvestmentCompare.init();
legacyFindAnAdviser.init();
civicCookie.init();
loadAmcharts.init();
loadWistiaVideo.init();
responsiveDropdown.init();
responsiveTabs.init();
wistiaVideo.init();

// Apps
searchApp.init();
loginApp.init();
dividendCaluclatorApp.init();
deviceDetectAndRedirectApp.init();
cashhubApp.init();
cashhubTableApp.init();
pdfForm.init();
factsetWidgets.init();

// Shared
complianceConfirm.init();
complianceReject.init();
fauxDropdown.init();
modal.init();
loginButton.init();
header.init();
nav.init();
regionsRolesModalToggle.init();
fundTable.init();
breadcrumb.init();
concertina.init();
contentNotAvailableMessage.init();
cookieBanner.init();
findAnAdviser.init();
adviserLocationMap.init();
navSearchToggle.init();
tabs.init();
forms.init();
personBioAlign.init();
showcase.init();
epiForm.init();
savedItems.init();
faqFeedback.init();
